import React from 'react';

const MIPdf = ({configurable}) => {
    return (
        <div className={"MIPdf"}>
            <iframe
                src={`${process.env.REACT_APP_API_URL + "/" + configurable.pdf}`}
                width="100%"
                height="700px"></iframe>
        </div>
    );
};

export default MIPdf;